


























import { FoundProductsFilter } from "@/model/find-products-response";
import { ProductListFilter } from "@/model/product-list-filter";
import Vue from "vue";

export default Vue.extend({
	name: "ProductRangeFilter",
	props: {
		activeFilter: {
			type: Object as () => ProductListFilter,
			required: true
		},
		filter: {
			type: Object as () => FoundProductsFilter,
			required: true
		},
		secondaryFilter: {
			type: Boolean,
			default: false
		},
		singleSelect: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		activeFilter() {
		},
		filter() {
		}
	},
	data() {
		return <{}>{};
	},
	computed: {
		from(): string {
			const currentFilterOptions = this.activeFilter.getFilterOptions(this.filter.name + "-from");
			return currentFilterOptions[0];
		},
		to(): string {
			const currentFilterOptions = this.activeFilter.getFilterOptions(this.filter.name + "-to");
			return currentFilterOptions[0];
		}
	},
	methods: {
		setFrom(value: string) {
			this.activeFilter.clearFilterOptions(this.filter.name + "-from");
			this.activeFilter.setFilterOptions(this.filter.name + "-from", [value]);
		},
		setTo(value: string) {
			this.activeFilter.clearFilterOptions(this.filter.name + "-to");
			this.activeFilter.setFilterOptions(this.filter.name + "-to", [value]);
		},
		apply() {
			this.$emit("updated");
		}
	}
});
